import handleChange, { handleInputChange } from '../../../utils/handleChange';
import addBoNumSlots, { handleTotalRooms } from '../supTripDateFun/addBoNumSlots';

export default function Price({ muBookData, setMuBookData, custom, handleAmount, roomsOptions, priceBasedOnCity }) {
    const slotsOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    return (
        <>
            {!custom && (
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>No. of Slots</label>
                    <div className='dropRegInputDiv'>
                        <select
                            value={muBookData.totalSeats}
                            name='totalSeats'
                            onChange={(e) => addBoNumSlots(e, setMuBookData, muBookData)}
                            required={true}
                            className='dropRegSelect'
                        >
                            <option value='-1'>Select</option>
                            {slotsOptions.map(function (val, typeIndex) {
                                return (
                                    <option key={typeIndex} value={val}>
                                        {val}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
            )}
            {!custom && priceBasedOnCity?.price?.room > 0 && roomsOptions.length > 0 && (
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>No. of Rooms</label>
                    <div className='dropRegInputDiv'>
                        <select
                            value={muBookData.totalRooms}
                            name='totalRooms'
                            onChange={(e) => handleTotalRooms(e, setMuBookData)}
                            required={true}
                            className='dropRegSelect'
                        >
                            <option value='-1'>Select</option>
                            {roomsOptions.map(function (val, typeIndex) {
                                return (
                                    <option key={typeIndex} value={val}>
                                        {val}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
            )}
            {muBookData?.startCity !== '-1' &&
                ((priceBasedOnCity?.price?.reserve ?? 0) > 0 || (priceBasedOnCity?.customPrice?.reserve ?? 0) > 0) && (
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Do you want to reserve?</label>
                        <div className='dropRegInputDiv radioDiv'>
                            <label>
                                <input
                                    type='radio'
                                    name='isReserved'
                                    value='true'
                                    checked={muBookData.amountPaid.isReserved === true}
                                    onChange={(e) =>
                                        handleAmount(
                                            {
                                                target: {
                                                    name: 'isReserved',
                                                    value: e.target.value === 'true'
                                                }
                                            },
                                            'amountPaid',
                                            false
                                        )
                                    }
                                />
                                Yes
                            </label>

                            <label>
                                <input
                                    type='radio'
                                    name='isReserved'
                                    value='false'
                                    checked={muBookData.amountPaid.isReserved === false}
                                    onChange={(e) =>
                                        handleAmount(
                                            {
                                                target: {
                                                    name: 'isReserved',
                                                    value: e.target.value === 'true'
                                                }
                                            },
                                            'amountPaid',
                                            false
                                        )
                                    }
                                />
                                No
                            </label>
                        </div>
                    </div>
                )}
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Actual Price</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={muBookData.amountPaid.actual}
                        name='actual'
                        onChange={(e) => handleAmount(e, 'amountPaid')}
                        type='Number'
                        placeholder={`Actual amount`}
                        className='dropRegSelect'
                        disabled={true}
                    ></input>
                </div>
            </div>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Tax</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={muBookData.amountPaid.tax}
                        name='tax'
                        onChange={(e) => handleAmount(e, 'amountPaid')}
                        type='Number'
                        placeholder={`Tax`}
                        className='dropRegSelect'
                        disabled={true}
                    ></input>
                </div>
            </div>
            {muBookData.amountPaid.isReserved &&
                (priceBasedOnCity?.price?.reserve > 0 || priceBasedOnCity?.customPrice?.reserve) && (
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Reserve Price</label>
                        <div className='dropRegInputDiv'>
                            <input
                                value={muBookData.amountPaid.reserve}
                                name='reserve'
                                onChange={(e) => handleAmount(e, 'amountPaid')}
                                type='Number'
                                placeholder={`Reserve amount`}
                                className='dropRegSelect'
                                disabled={true}
                            ></input>
                        </div>
                    </div>
                )}
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Total</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={muBookData.amountPaid.total}
                        name='total'
                        onChange={(e) => handleAmount(e, 'amountPaid')}
                        type='Number'
                        placeholder={`Total Amount`}
                        className='dropRegSelect'
                        disabled={true}
                    ></input>
                </div>
            </div>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Paid</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={muBookData.amountPaid.paid}
                        name='paid'
                        onChange={(e) => handleAmount(e, 'amountPaid')}
                        type='Number'
                        placeholder={`Amount Paid`}
                        className='dropRegSelect'
                    ></input>
                </div>
            </div>
        </>
    );
}
